<template>
  <div class="modal custom-fade fade" id="edit_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 class="mb-0">Edit Expenses new</h4>
          </div>
          <button
            type="button"
            class="close"
            @click="closeModal"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="editExpenses" id="myform">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Customer</label>
                  <selectMenu
                        v-model="selectedCustomer"
                        :options="customers"
                        label="Customer"
                        optionAttribute="name"
                        placeholder="Search Customer"
                        searchAttribute="name"
                      />
                </div>
                <div class="row">
                  <div class="form-group col-lg-6 col-md-6 col-sm-12">
                    <label>Currency</label>
                    <select
                      v-model="form.currency"
                      class="form-select"
                      required
                    >
                      <option value="NGN : Naira" selected required>
                        NGN : Naira
                      </option>
                      <option
                        v-for="(currency, index) in allCurrencyCodes"
                        :key="index"
                        :value="currency"
                      >
                        {{ currency }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Amount </label>
                      <input
                        type="number"
                        v-model="form.amount"
                        class="form-control"
                        placeholder="Enter Amount"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Expense Date </label>
                      <datepicker
                        v-model="form.date"
                        class="picker"
                        :editable="true"
                        :clearable="false"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-upload-label">
                      <label class="mb-0"
                        >Attachment<span class="text-muted"
                          >(Optional)</span
                        ></label
                      >
                    </div>
                    <div class="form-upload-file" style="overflow: hidden">
                      <span
                        ><i class="feather feather-upload-cloud me-2"></i
                        >{{ imageName ? imageName : "Attach File" }}</span
                      >
                      <input
                        type="file"
                        @change="onChangeFile"
                        id="image_sign"
                      />
                      <div id="frames"></div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Notes</label>
                    <textarea
                      type="text"
                      v-model="form.notes"
                      class="form-control"
                      placeholder="Enter Notes"
                    ></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label
                        >Mark as recurring
                        <span class="text-muted">(Optional)</span></label
                      >
                      <div class="status-toggle mt-4" style="margin-left: 20px">
                        <div class="d-flex">
                          <input
                            id="rating_1"
                            class="check"
                            @change="toggleRecurring"
                            :true-value="1"
                            :false-value="0"
                            v-model="form.recurring"
                            type="checkbox"
                          />
                          <label for="rating_1" class="checktoggle checkbox-bg"
                            >checkbox</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="form.recurring === 1">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Recurring Duration Mode</label>
                      <select
                        class="form-select"
                        v-model="form.recurring_duration.mode"
                      >
                        <option :value="null">Select Mode</option>
                        <option value="day">Daily</option>
                        <option value="week">Weekly</option>
                        <option value="month">Monthly</option>
                        <option value="year">Annually</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Recurring Duration Value </label>
                      <input
                        type="number"
                        v-model="form.recurring_duration.value"
                        class="form-control"
                        placeholder="Enter Duration Value"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button data-bs-dismiss="modal" type="button" class="btn btn-primary cancel me-2">
              Cancel
            </button>
            <button type="submit" :disabled="isLoading" class="btn btn-primary">
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-if="!isLoading">Update Expense</span>
              <span v-if="isLoading">Updating...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, onMounted, watch, defineEmits, defineProps } from "vue";
import { useStore } from "vuex";
import {
  formatDateToDashDigits,
} from "@/assets/composables/date";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
const currencyCodes = require("currency-codes");

// Get all currency codes
const allCurrencyCodes = computed(() => {
  return currencyCodes.data.map(
    (currency) => `${currency.code} : ${currency.currency}`
  );
});

const emit = defineEmits(["closeEditModal"]);

const props = defineProps({
  form: {
    type: [Object, Function],
  },
  expenseID: {
    type: Number,
  },
});
const selectedCustomer = ref(null);
const store = useStore();
const isLoading = ref(false);

const imageName = ref("");

const onChangeFile = (event) => {
  imageName.value = event.target.files[0].name;
  props.form.attachment = event.target.files[0];
};

const customers = computed(() => {
  return store.getters["customer/customers"].data;
});

const getCustomers = () => {
  let data = {
    page: 1,
    per_page: 1000,
    query: "",
  };
  store.dispatch("customer/getCustomers", data);
};

const closeModal = () => {
  emit("closeEditModal");
  imageName.value = "";
  resetForm();
};

const resetForm = () => {
  const form = document.getElementById("myform");
  form.reset();
};

watch(
  [customers, () => props.form.customer_id],
  ([newCustomers, newCustomerId]) => {
    if (newCustomers && newCustomers.length > 0 && newCustomerId) {
      const matchedCustomer = newCustomers.find(c => c.id === newCustomerId);
      selectedCustomer.value = matchedCustomer
    }
  },
  { immediate: true }
);


const editExpenses = () => {
  if (props.form.recurring === '1' || props.form.recurring === 1 && 
  (props.form.recurring_duration.mode == null || props.form.recurring_duration.mode == '' || props.form.recurring_duration.value == null || props.form.recurring_duration.value == '')) {
     toast.error("Reoccurring is active: Please enter a reoccurring duration");
  }
  else {
    isLoading.value = true;
    let data = {
      id: props.expenseID,
      payload: {
        customer_id: selectedCustomer.value.id,
        date: formatDateToDashDigits(props.form.date),
        amount: props.form.amount,
        notes: props.form.notes,
        currency: props.form.currency,
        recurring: props.form.recurring,
        recurring_duration: {
          mode: props.form.recurring_duration.mode,
          value: props.form.recurring_duration.value,
        },
        attachment: props.form.attachment,
      },
    };
  store
    .dispatch("expenses/editExpenses", data)
    .then(() => {
      isLoading.value = false;
      closeModal();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
  }
};
const toggleRecurring = () => {
  if (props.form.recurring === 1) {
    props.form.recurring = 1;
  } else {
    props.form.recurring = 0;
    props.form.recurring_duration.value = null
    props.form.recurring_duration.mode = null
  }
};

onMounted(() => {
  getCustomers();
});
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
